import { useEffect, useState } from 'react';
import { wieBenIk } from '../lib/api';
import HomePage from './HomePage';
import InlogPage from './InlogPage';

/**
 * De poort voor `/`: eerst kijken of je binnen bent, dan pas het beheer tonen.
 *
 * WAAROM DIT EEN EIGEN SCHERM IS EN GEEN CONTROLE IN HomePage. HomePage is het
 * formulier voor een nieuw gesprek en doet verder niets met toegang. Zet je die
 * controle daarin, dan staan twee onderwerpen door elkaar in een bestand dat al
 * groot is.
 *
 * DIT IS GEEN SLOT. Het slot zit op de server: elke beheerroute weigert zonder
 * geldig cookie. Dit scherm bepaalt alleen WAT JE ZIET. Wie hier omheen knutselt
 * in zijn browser, krijgt bij het aanmaken van een kamer gewoon een 401.
 */
type Stand = 'kijken' | 'binnen' | 'buiten';

export default function BeheerPage() {
  const [stand, setStand] = useState<Stand>('kijken');

  useEffect(() => {
    let nogNodig = true;
    void wieBenIk()
      .then(() => {
        if (nogNodig) setStand('binnen');
      })
      .catch(() => {
        // Elke fout leidt hier naar het inlogscherm, ook een netwerkfout. Het
        // alternatief is het beheer tonen aan iemand die misschien buiten
        // staat, en dat levert alleen maar 401'en op bij de eerste knop.
        if (nogNodig) setStand('buiten');
      });
    return () => {
      nogNodig = false;
    };
  }, []);

  // Bewust leeg tijdens het kijken. Dit duurt één verzoek naar de eigen server;
  // een laadmelding die korter staat dan je hem kunt lezen, is alleen geflikker.
  if (stand === 'kijken') return null;

  return stand === 'binnen' ? (
    <HomePage opUitgelogd={() => setStand('buiten')} />
  ) : (
    <InlogPage opGelukt={() => setStand('binnen')} />
  );
}
